/* eslint-disable no-console */
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var setupDebugger = function () {
    var DebugModeKey = 'vrlcm-ui-debug-mode';
    if (window && window.localStorage) {
        window.enableDebugMode = function () {
            window.localStorage.setItem(DebugModeKey, 'true');
            console.log('Debug mode enabled');
        };
        window.disableDebugMode = function () {
            window.localStorage.removeItem(DebugModeKey);
            console.log('Debug mode disabled');
        };
        return function () { return window.localStorage.getItem(DebugModeKey) === 'true'; };
    }
    else {
        console.log('window or window.localStorage is undefined, could not register debug mode functions.');
        return function () { return false; };
    }
};
var isDebugModeEnabled = setupDebugger();
/**
 * Debug logger for logging critical errors in javascript code.
 * By default logs are not printed on console.
 *
 * To enable debugger, in dev console execute `window.enableDebugMode()`
 * To disable debugger, in dev console execute `window.disableDebugMode()`
 */
export var debugLogger = function (message) {
    var optionalParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        optionalParams[_i - 1] = arguments[_i];
    }
    if (!isDebugModeEnabled()) {
        return;
    }
    var now = new Date();
    var prefix = "Debug log : " + now.toLocaleString() + " :: ";
    var prefixErrorInstance = "Debug log : " + now.toLocaleString() + " : found 'Error' instance :: ";
    console.log(prefix, message, optionalParams);
    __spreadArrays([message], optionalParams).forEach(function (o) {
        if (o instanceof Error) {
            console.log(prefixErrorInstance, 'error - ', o, ', stringified version - ', JSON.stringify(o));
        }
    });
};
